
(function () {
  const grids = document.querySelectorAll("[data-bento-collection-section]");
  grids.forEach(function (grid) {
    const MAX_CARDS = 9;
    const cards = Array.from(grid.querySelectorAll(".collection-card"));
    if (!cards.length) return;

    // Remove extra cards beyond limit
    cards.slice(MAX_CARDS).forEach((card) => card.remove());
  });
})();